import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { login, clearError } from '../store/slices/authSlice';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error, isAuthenticated } = useSelector((state) => state.auth);

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/');
    }
  }, [isAuthenticated, navigate]);

  useEffect(() => {
    return () => {
      dispatch(clearError());
    };
  }, [dispatch]);

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(login({ email, password }));
  };

  return (
    <div className="login-page-wrapper">
      <div className="login-left-panel">
        <h1>Welkom terug</h1>
        <p>Beheer uw productie, volg orders en optimaliseer uw workflow met het Tafelzeil Online dashboard.</p>

        <div className="login-features">
          <div className="login-feature">
            <i className="bi bi-speedometer2"></i>
            <span>Real-time productie monitoring</span>
          </div>
          <div className="login-feature">
            <i className="bi bi-box-seam"></i>
            <span>Slimme orderclustering</span>
          </div>
          <div className="login-feature">
            <i className="bi bi-graph-up-arrow"></i>
            <span>Geavanceerde rapportages</span>
          </div>
          <div className="login-feature">
            <i className="bi bi-gear"></i>
            <span>Machine integraties</span>
          </div>
        </div>
      </div>

      <div className="login-right-panel">
        <div className="login-form-container">
          <div className="login-logo">
            <img
              src="/logo.svg"
              alt="Tafelzeil Online"
              style={{ maxWidth: '200px', height: 'auto', marginBottom: '1rem' }}
            />
            <p>Productie Dashboard</p>
          </div>

          {error && (
            <div className="alert alert-danger">
              <i className="bi bi-exclamation-triangle me-2"></i>
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="login-form">
            <div className="form-group">
              <label htmlFor="email">E-mailadres</label>
              <div className="input-group">
                <span className="input-group-text">
                  <i className="bi bi-envelope"></i>
                </span>
                <input
                  type="email"
                  id="email"
                  className="form-control"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="uw@email.nl"
                  required
                  autoFocus
                />
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="password">Wachtwoord</label>
              <div className="input-group">
                <span className="input-group-text">
                  <i className="bi bi-lock"></i>
                </span>
                <input
                  type="password"
                  id="password"
                  className="form-control"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Voer uw wachtwoord in"
                  required
                />
              </div>
            </div>

            <button
              type="submit"
              className="btn btn-primary btn-login"
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Inloggen...
                </>
              ) : (
                <>
                  <i className="bi bi-box-arrow-in-right me-2"></i>
                  Inloggen
                </>
              )}
            </button>
          </form>

          <div className="login-footer">
            <p>Problemen met inloggen? <a href="mailto:support@tafelzeilonline.com">Neem contact op</a></p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
